// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"container_tta8L","face":"face_zaeHv","features":"features_zp_Rj"};